import { SortDirection } from "./sort-direction.enum";


export class SortArgument {
    public columnName: string;
    public direction: SortDirection;
}
